module.exports = __webpack_public_path__ + "static/media/strong03.7ea0a0c3.jpg";